(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cgs-flexible-content"] && !Shopify.designMode) return;
  try {
    
  /* Shares the `__vlbInit` guard with blocks/video-lightbox.liquid, so the
     overlay is only ever created once even if both are on the same page. */
  (function () {
    if (window.__vlbInit) return;
    window.__vlbInit = true;

    var overlay = document.createElement('div');
    overlay.className = 'vlb-overlay';
    overlay.hidden = true;
    overlay.innerHTML =
      '<button type="button" class="vlb-close" aria-label="Close video">&times;</button>' +
      '<div class="vlb-player"></div>';
    document.body.appendChild(overlay);

    var player = overlay.querySelector('.vlb-player');
    var closeBtn = overlay.querySelector('.vlb-close');
    var lastTrigger = null;

    function open(src, trigger) {
      lastTrigger = trigger;
      var video = document.createElement('video');
      video.src = src;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      player.appendChild(video);
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function close() {
      if (overlay.hidden) return;
      player.innerHTML = ''; // removes video, stops playback
      overlay.hidden = true;
      document.body.style.overflow = '';
      if (lastTrigger) lastTrigger.focus();
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.vlb-trigger');
      if (trigger) open(trigger.dataset.videoSrc, trigger);
    });

    closeBtn.addEventListener('click', close);

    overlay.addEventListener('click', function (e) {
      if (!player.contains(e.target)) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cgs-video-grid"] && !Shopify.designMode) return;
  try {
    
  /* Shares the `__vlbInit` guard with blocks/video-lightbox.liquid. */
  (function () {
    if (window.__vlbInit) return;
    window.__vlbInit = true;

    var overlay = document.createElement('div');
    overlay.className = 'vlb-overlay';
    overlay.hidden = true;
    overlay.innerHTML =
      '<button type="button" class="vlb-close" aria-label="Close video">&times;</button>' +
      '<div class="vlb-player"></div>';
    document.body.appendChild(overlay);

    var player = overlay.querySelector('.vlb-player');
    var closeBtn = overlay.querySelector('.vlb-close');
    var lastTrigger = null;

    function open(src, trigger) {
      lastTrigger = trigger;
      var video = document.createElement('video');
      video.src = src;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      player.appendChild(video);
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function close() {
      if (overlay.hidden) return;
      player.innerHTML = ''; // removes video, stops playback
      overlay.hidden = true;
      document.body.style.overflow = '';
      if (lastTrigger) lastTrigger.focus();
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.vlb-trigger');
      if (trigger) open(trigger.dataset.videoSrc, trigger);
    });

    closeBtn.addEventListener('click', close);

    overlay.addEventListener('click', function (e) {
      if (!player.contains(e.target)) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
